<template>
  <div class v-if="data && data.length>0">
    <div
      class="border-left-primary font-weight-bolder h5 mb-1"
      style="padding: 4px 0 4px 4px; border-left-width: 4px;"
    >{{ $t('lbl_customer_document_definition') }}</div>
    <b-row>
      <b-col v-for="item in data" :key="item.id" cols="12" md="6">
        <b-form-group :label="item.title">
          <div>
            <div @click="handleChoseFile(item.id)" class="upload-btn mb-2">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.25842 6.42508L9.16675 4.50841V12.5001C9.16675 12.7211 9.25455 12.9331 9.41083 13.0893C9.56711 13.2456 9.77907 13.3334 10.0001 13.3334C10.2211 13.3334 10.4331 13.2456 10.5893 13.0893C10.7456 12.9331 10.8334 12.7211 10.8334 12.5001V4.50841L12.7417 6.42508C12.8192 6.50318 12.9114 6.56518 13.0129 6.60749C13.1145 6.64979 13.2234 6.67158 13.3334 6.67158C13.4434 6.67158 13.5523 6.64979 13.6539 6.60749C13.7554 6.56518 13.8476 6.50318 13.9251 6.42508C14.0032 6.34761 14.0652 6.25544 14.1075 6.15389C14.1498 6.05234 14.1716 5.94342 14.1716 5.83341C14.1716 5.7234 14.1498 5.61448 14.1075 5.51293C14.0652 5.41138 14.0032 5.31921 13.9251 5.24174L10.5917 1.90841C10.5125 1.83254 10.419 1.77307 10.3167 1.73341C10.1139 1.65006 9.8863 1.65006 9.68342 1.73341C9.58112 1.77307 9.48767 1.83254 9.40841 1.90841L6.07508 5.24174C5.99738 5.31944 5.93575 5.41168 5.8937 5.5132C5.85165 5.61472 5.83001 5.72353 5.83001 5.83341C5.83001 5.94329 5.85165 6.0521 5.8937 6.15362C5.93575 6.25514 5.99738 6.34738 6.07508 6.42508C6.15278 6.50278 6.24502 6.56441 6.34654 6.60646C6.44806 6.64851 6.55687 6.67015 6.66675 6.67015C6.77663 6.67015 6.88544 6.64851 6.98696 6.60646C7.08847 6.56441 7.18072 6.50278 7.25842 6.42508ZM17.5001 10.0001C17.2791 10.0001 17.0671 10.0879 16.9108 10.2442C16.7545 10.4004 16.6667 10.6124 16.6667 10.8334V15.8334C16.6667 16.0544 16.579 16.2664 16.4227 16.4227C16.2664 16.5789 16.0544 16.6667 15.8334 16.6667H4.16675C3.94573 16.6667 3.73377 16.5789 3.57749 16.4227C3.42121 16.2664 3.33341 16.0544 3.33341 15.8334V10.8334C3.33341 10.6124 3.24562 10.4004 3.08934 10.2442C2.93306 10.0879 2.7211 10.0001 2.50008 10.0001C2.27907 10.0001 2.06711 10.0879 1.91083 10.2442C1.75455 10.4004 1.66675 10.6124 1.66675 10.8334V15.8334C1.66675 16.4965 1.93014 17.1323 2.39898 17.6012C2.86782 18.07 3.50371 18.3334 4.16675 18.3334H15.8334C16.4965 18.3334 17.1323 18.07 17.6012 17.6012C18.07 17.1323 18.3334 16.4965 18.3334 15.8334V10.8334C18.3334 10.6124 18.2456 10.4004 18.0893 10.2442C17.9331 10.0879 17.7211 10.0001 17.5001 10.0001Z"
                  fill="#20419B"
                />
              </svg>

              <span class="ml-1 fs-14 txt-pri">{{ $t('lbl_choose_file') }}</span>
            </div>
          </div>
          <b-row>
            <b-col>
              <b-img
                class="preview-image__item rounded cursor-pointer"
                v-if="item.selectedFile && item.isImage"
                :src="item.selectedFile"
                :style="{
                  height: `64px`
                }"
                @click="handleClickFile(item.selectedFile,item.isImage)"
              />
              <div
                class="d-flex align-items-center"
                v-if="item.selectedFile&&item.selectedFile.url && !item.isImage"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
                    fill="#20419B"
                  />
                </svg>
                <div
                  @click="handleClickFile(item.selectedFile,item.isImage)"
                  style="flex:1"
                  class="fs-14 cs-text cursor-pointer"
                >{{ (item.selectedFile.name ) }}</div>
              </div>
            </b-col>
          </b-row>
        </b-form-group>
        <input
          hidden
          :ref="`refInputEl-${item.id}`"
          type="file"
          :placeholder="$t('lbl_choose_file')"
          @input="e=>handleSelectFile(e,item)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import useOrdersList from "../../useOrdersList";

export default {
  name: "Definition",
  props: {
    dataProp: Array,
    ordersId: Number
  },
  setup() {
    const { uploadFileDefinition } = useOrdersList();
    return {
      uploadFileDefinition
    };
  },
  data() {
    return {
      data: []
    };
  },
  mounted() {
    this.handleMapData();
  },
  watch: {
    dataProp: {
      handler() {
        this.handleMapData();
      },
      deep: true
    }
  },
  methods: {
    handleMapData() {
      if (this.dataProp) {
        this.data = this.dataProp?.map(item => {
          const fileName = item?.url?.substring(
            item?.url?.lastIndexOf("/") + 1
          );

          const newFile = this.checkImage(item?.url)
            ? item.url
            : { url: item.url, name: fileName };

          return {
            ...item,
            selectedFile: newFile,
            isImage: this.checkImage(item?.url)
          };
        });
      }
    },
    handleSelectFile(e, item) {
      const file = e.target.files[0];
      if (!file) return;
      const fileType = file["type"];
      const validImageTypes = [
        "image/gif",
        "image/jpeg",
        "image/png",
        "image/jpg"
      ];

      this.$store.commit("orders/updateLoading", true);

      if (validImageTypes.includes(fileType)) {
        const reader = new FileReader();

        reader.addEventListener(
          "load",
          () => {
            item.selectedFile = reader.result;
          },
          false
        );

        if (file) {
          reader.readAsDataURL(file);
          item.isImage = true;
        }
      } else {
        item.isImage = false;
        item.selectedFile = file;
      }

      this.uploadFileDefinition(file, item.id, this.ordersId);
    },
    handleChoseFile(id) {
      this.$refs[`refInputEl-${id}`][0].click();
    },
    checkImage(path) {
      const imageExtensions = [".jpg", ".jpeg", ".png", ".gif"];

      const extension = path.substring(path.lastIndexOf(".")).toLowerCase();
      if (imageExtensions.includes(extension)) {
        return true;
      }

      return false;
    },
    handleClickFile(selectedFile, isImage) {
      const url = isImage ? selectedFile : selectedFile.url;
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-btn {
  width: 150px;
  border: 1px dashed #20419b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 9px;
  cursor: pointer;
}
.cs-text {
  text-decoration: underline;
}
</style>
